import originAxios from 'axios';
import store from '@/store/index';
import CustomError from './custom-err';
import getErrCodeTrans from './get-err-code-trans';
const service = originAxios.create({
  baseURL: `${window.location.origin}/api/v1`,
  timeout: 20000,
  headers: {
    common: {
      accept: 'application/prs.tiga.v1+json',
      'x-app-refer': 'tiga',
    },
  },
});

const langObj = {
  'zh-cn': 'zh-CN',
  en: 'en',
};

service.interceptors.request.use(
  res => {
    const lang = store.state.navLang;
    const userInfoUpdateAt = getLocal('userInfoUpdateAt');
    if (lang) {
      res.headers.lang = langObj[lang] || 'en';
    }
    if (store.state.env.conversationId) {
      res.headers.conversationId = store.state.env.conversationId;
    }
    if (userInfoUpdateAt && userInfoUpdateAt > +store.state.userInfo.updateAt) {
      //ios 页面缓存导致 localStorage 和 vuex 里 token 不一致 从而退出登录
      store.commit('loadUserInfoFromLocal');
    }
    if (store.state.userInfo.token) {
      if (new Date().getTime() > store.state.userInfo.tokenExpiresAt) {
        // token 过期 尝试更新
        return originAxios({
          url: '/auth/current',
          baseURL: `${window.location.origin}/api/v1`,
          method: 'put',
          headers: {
            common: {
              accept: 'application/prs.tiga.v1+json',
              'x-app-refer': 'tiga',
              Authorization: `Bearer ${store.state.userInfo.token}`,
            },
          },
          timeout: 10000,
        })
          .then(_data => {
            store.commit('setUserInfo', {
              token: _data.data.data.token,
              tokenExpiresAt: (_data.data.data.expiresAt - 30 * 60) * 1000,
            });
            res.headers.common[
              'Authorization'
            ] = `Bearer ${store.state.userInfo.token}`;
            return Promise.resolve(res);
          })
          .catch(err => {
            errHandler(
              new CustomError(err, {
                isResponse: true,
              }),
            );
            store.commit('setUserInfo', { isLogin: false });
            return Promise.resolve(res);
          });
      } else {
        res.headers.common[
          'Authorization'
        ] = `Bearer ${store.state.userInfo.token}`;
        return Promise.resolve(res);
      }
    }
    return Promise.resolve(res);
  },
  err => {
    return Promise.reject(err);
  },
);

service.interceptors.response.use(
  res => Promise.resolve(res),
  err => {
    let $t;
    if (window.vueInstance) {
      $t = function() {
        return window.vueInstance.$t.apply(window.vueInstance, arguments);
      };
    } else {
      $t = msg => msg;
    }
    let customError = null;
    if (err.response && err.response.data) {
      // 如果不存在code，则报服务器错误
      const code =
        (err.response.data.code && err.response.data.code.toString()) || '400';
      let msg = getErrCodeTrans(code);
      switch (code) {
        case '40000':
        case '40001':
        case '40003':
        case '40004':
          store.commit('setUserInfo', { isLogin: false });
          break;
        case '40002':
          return new Promise((resolve, reject) => {
            originAxios({
              url: '/auth/current',
              baseURL: `${window.location.origin}/api/v1`,
              method: 'put',
              headers: {
                common: {
                  accept: 'application/prs.tiga.v1+json',
                  'x-app-refer': 'tiga',
                  Authorization: `Bearer ${store.state.userInfo.token}`,
                },
              },
              timeout: 20000,
            })
              .then(_data => {
                const d = _data.data.data;
                store.commit('setUserInfo', { token: d.token });
                customError = new CustomError(
                  responseError(err, $t('error.jwtUpdated'), code),
                  {
                    isResponse: true,
                  },
                );
                errHandler(customError);
                reject(customError);
              })
              .catch(_err => {
                // eslint-disable-next-line no-console
                console.warn(_err);
                store.commit('setUserInfo', { isLogin: false });
                customError = new CustomError(
                  responseError(err, $t('error.jwtInvalid'), code),
                  {
                    isResponse: true,
                  },
                );
                errHandler(customError);
                reject(customError);
              });
          });
      }
      if (msg) {
        customError = new CustomError(responseError(err, $t(msg), code), {
          isResponse: true,
        });
      } else {
        customError = new CustomError(err, { isResponse: true });
      }
    } else if (err.code == 'ECONNABORTED') {
      //超时
      customError = new CustomError(
        responseError(err, $t('error.reqTimeout')),
        {
          isResponse: true,
        },
      );
    } else if (err.code == 'Network Error') {
      //网络错误
      customError = new CustomError(
        responseError(err, $t('error.networkError')),
        {
          isResponse: true,
        },
      );
    } else {
      customError = new CustomError(err, { isResponse: true });
    }
    errHandler(customError);
    return Promise.reject(customError);
  },
);

export default service;

function responseError(err, message, code) {
  // 包装错误类
  const e = Object.create(err);
  e.stack = err.stack || new Error().stack;
  e.name = 'Response Error';
  if (code !== undefined) {
    e.prevCode = e.code;
    e.code = code;
  }
  e.isWrapped = true;
  if (message !== undefined) {
    e.prevMsg = e.message;
    e.message = message;
  }
  return e;
}

function getLocal(key) {
  let value = '';
  try {
    value = window.localStorage.getItem(key);
  } catch (e) {
    //
  }
  return value;
}

function errHandler(err) {
  // 403 不发送至 sentry
  if (err.response && err.response.status == '403') return;
  if (window.vueInstance && window.vueInstance.$sendErr) {
    window.vueInstance.$sendErr.call(window.vueInstance, err);
  }
}
